<template>
  <div>
    <div class="router-view-container">
      <transition
        :name="transitionName"
        mode="out-in"
        @before-enter="handleBeforeEnter"
      >
        <router-view v-slot="{ Component, route }">
          <component :is="Component" :key="route.path" />
        </router-view>
      </transition>
    </div>

    <LoadingSpinner :loading="$store.state.LoadingStatus"></LoadingSpinner>
  </div>
</template>

<script>
import LoadingSpinner from './components/LoadingSpinner.vue'
import { useAppTheme } from './composables/useAppTheme'

export default {
  name: 'App',
  components: {
    LoadingSpinner,
  },
  setup() {
    const theme = useAppTheme()
    return { theme }
  },
  data() {
    return {
      transitionName: '',
      isFirstLoad: true,
    }
  },
  methods: {
    handleBeforeEnter(el) {
      if (this.$route.path === '/idcard') {
        window.scrollTo(0, 0)
      }
    },
  },
  watch: {
    $route(to, from) {
      if (to.path === '/') {
        if (this.isFirstLoad) {
          this.isFirstLoad = false
          this.transitionName = ''
        } else {
          if (from.path === '/idcard') {
            this.transitionName = 'slide-down'
          } else {
            this.transitionName = 'slide-left'
          }
        }
      } else if (to.path === '/idcard') {
        this.transitionName = 'slide-up'
      } else if (from.path === '/reserve/form' && to.path === '/reserve') {
        this.transitionName = 'slide-left'
      } else if (from.path === '/notebook/form' && to.path === '/notebook') {
        this.transitionName = 'slide-left'
      } else {
        this.transitionName = 'slide-right'
      }
    },
  },
}
</script>

<style>
/* 시설물 예약 신청 툴팁 짤림 현상 */
.router-view-container {
  overflow: hidden;
}

/* ─── Page Transitions (개선된 애니메이션) ─── */
.slide-left-enter-active,
.slide-right-enter-active,
.slide-up-enter-active,
.slide-down-enter-active {
  transition: all 0.3s cubic-bezier(0.2, 0, 0, 1);
}

.slide-left-leave-active,
.slide-right-leave-active,
.slide-up-leave-active,
.slide-down-leave-active {
  transition: all 0.25s cubic-bezier(0.3, 0, 0.8, 0.15);
}

.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active,
.slide-up-enter-active,
.slide-up-leave-active,
.slide-down-enter-active,
.slide-down-leave-active {
  will-change: transform, opacity;
}

.slide-left-enter-active,
.slide-right-enter-active,
.slide-up-enter-active,
.slide-down-enter-active {
  z-index: 2;
}

.slide-left-leave-active,
.slide-right-leave-active,
.slide-up-leave-active,
.slide-down-leave-active {
  z-index: 2;
}

.slide-left-enter-from {
  opacity: 0;
  transform: translateX(-60px);
}
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-60px);
}

.slide-right-enter-from {
  opacity: 0;
  transform: translateX(60px);
}
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(60px);
}

.slide-up-enter-from {
  opacity: 0;
  transform: translateY(100%);
}
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(100%);
}

.slide-down-enter-from {
  opacity: 0;
  transform: translateY(-60px);
}
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-60px);
}

body.no-scroll {
  overflow: hidden;
  width: 100%;
  height: 100vh;
}
</style>
